import React, { useContext } from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import NoQuestionsResult from './NoQuestionsResult/NoQuestionsResult';
import QuestionsResultsFound from './QuestionsResultsFound/QuestionsResultsFound';
import { useQuestions } from '../../../../hooks/useQuestions';
import { st, classes } from '../Widget.st.css';
import { DATA_HOOKS } from '../../../../constants/dataHooksElements';
import { AppContext } from '../SettingsProvider/SettingsProvider';

export interface Props {
  questions: QuestionEntry[];
}

const QuestionsWrapper = ({ questions }: Props) => {
  const { fetchError } = useContext(AppContext);

  const { questionsList, bottomRef } = useQuestions(questions);
  if (fetchError) {
    return null;
  }
  return (
    <>
      {questionsList.length > 0 ? (
        <QuestionsResultsFound questionsList={questionsList} />
      ) : (
        <NoQuestionsResult />
      )}
      <div
        data-hook={DATA_HOOKS.QUESTIONS_WRAPPER}
        ref={bottomRef}
        className={st(classes.bottomBody)}
      />
    </>
  );
};

export default QuestionsWrapper;
